import type { ReactNode } from "react";
import { ShieldCheck } from "lucide-react";
import { Logo } from "@/components/bits";
import { LanguageSwitcher } from "@/i18n/i18n-context";

export function AuthLayout({
  badge,
  title,
  children,
}: {
  badge: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <main className="grid min-h-[100dvh] bg-[#f4f7fb] lg:grid-cols-[1.05fr_0.95fr]">
      <section className="relative hidden overflow-hidden bg-[#061a45] p-12 text-white lg:flex lg:flex-col lg:justify-between">
        <div className="absolute -right-40 -top-40 h-96 w-96 rounded-full bg-cyan-400/15 blur-3xl" />
        <div className="absolute -bottom-32 left-20 h-80 w-80 rounded-full bg-emerald-400/15 blur-3xl" />
        <Logo light />
        <div className="relative max-w-xl">
          <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-cyan-200">
            <ShieldCheck className="h-4 w-4" /> {badge}
          </p>
          <h1 className="text-5xl font-black leading-[1.08] tracking-tight">
            {title}
          </h1>
        </div>
        <p className="relative text-xs text-slate-400">
          © 2026 BizConnectPay. Connexion chiffrée.
        </p>
      </section>
      <section className="relative flex items-center justify-center px-5 py-10 sm:px-10">
        <div className="absolute right-5 top-5">
          <LanguageSwitcher variant="auth" />
        </div>
        <div className="w-full max-w-md">
          <div className="mb-8 lg:hidden">
            <Logo />
          </div>
          {children}
        </div>
      </section>
    </main>
  );
}
